module.exports = __webpack_public_path__ + "static/img/2.e776055a.png";